import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ExternalLink } from '@/components/ui/ExternalLink';
import { TRFBirdMark, TRFWordmark } from '@/components/brand/TRFLogo';
import { useAuth } from '@/contexts/AuthContext';
import { homeFor } from '@/lib/home-route';
import { ORG_NAME } from './org-name';

const TRF_URL = 'https://www.trf.org';

export function StevensFooter() {
  const { user, loading } = useAuth();
  const { t } = useTranslation('shell');
  const year = new Date().getFullYear();
  return (
    <footer className="foot">
      <div className="inner">
        <div className="col brand-col">
          {/* #881: public chrome carries TRF identity, not the in-product
              companion persona. Colour comes from `.landing-page .brand`. */}
          <div className="brand">
            <TRFBirdMark height={30} />
            <TRFWordmark height={22} className="wordmark" />
            <span className="sr-only" translate="no">{ORG_NAME}</span>
          </div>
          <p>{t('publicChrome.footer.tagline')}</p>
        </div>
        <div className="col">
          <h4>{t('publicChrome.footer.platform')}</h4>
          <a href="/welcome#what">{t('publicChrome.footer.whatsInside')}</a>
          <a href="/welcome#trust">{t('publicChrome.footer.trustAndPrivacy')}</a>
          <a href="/welcome#faq">{t('publicChrome.footer.faq')}</a>
          {/* B-164 (B-163 follow-up): same three-state auth slot as the topbar
              and hero. The hydrating placeholder is an href-less <a> so it
              keeps the .foot .col a box (display:block + padding) without
              being focusable or carrying the link role — the column must not
              gain a row when the async auth boot resolves. */}
          {user ? (
            <Link to={homeFor(user.role)} title={t('publicChrome.signedInAs', { email: user.email })}>
              {t('publicChrome.myAccount')}
            </Link>
          ) : loading ? (
            <a aria-hidden="true" className="invisible">
              {t('publicChrome.signIn')}
            </a>
          ) : (
            <Link to="/login">{t('publicChrome.signIn')}</Link>
          )}
        </div>
        <div className="col">
          <h4>{t('publicChrome.footer.foundation')}</h4>
          <ExternalLink href={TRF_URL}><span translate="no">trf.org ↗</span></ExternalLink>
          <ExternalLink href={`${TRF_URL}/who-we-are/our-mission`}>
            {t('publicChrome.footer.ourMission')}
          </ExternalLink>
          <ExternalLink href={`${TRF_URL}/who-we-are/tylers-story`}>
            {t('publicChrome.footer.tylersStory')}
          </ExternalLink>
          <ExternalLink href={`${TRF_URL}/donate`}>{t('publicChrome.footer.donate')}</ExternalLink>
        </div>
        <div className="col">
          <h4>{t('publicChrome.footer.legal')}</h4>
          <Link to="/privacy">{t('publicChrome.footer.privacyPolicy')}</Link>
          <Link to="/terms">{t('publicChrome.footer.termsOfService')}</Link>
          <Link to="/sms-terms">{t('publicChrome.footer.smsTerms')}</Link>
          {/* GH-271.4: cookie policy + the full legal index, reachable by nav */}
          <Link to="/legal/cookies">{t('publicChrome.footer.cookiePolicy')}</Link>
          <Link to="/legal">{t('publicChrome.footer.allLegal')}</Link>
        </div>
      </div>
      <div className="copy">
        <span>{t('publicChrome.footer.copyright', { year, org: ORG_NAME })}</span>
        <span>{t('publicChrome.footer.builtWithCare')}</span>
      </div>
    </footer>
  );
}
